import { createContext, useState } from "react";

export const VNeIDJobContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    let emptyValue = {
        id: "",
        jobKey: "",
        jobName: "",
        className: "",
        jobGroup: "",
        cronExpression: "",
        configRow: "",
        description: "",
        multipleJobs: false,
        server: null,
    };

    const [valueForm, setValueForm] = useState(emptyValue);
    const [vneidDialog, setVneidDialog] = useState(false);
    const [index, setIndex] = useState(-1);
    const [submitted, setSubmitted] = useState(false);

    const resetValueForm = () => {
        setValueForm(emptyValue);
    };
    // Make the context object:
    const vneidJobContext = {
        vneidDialog,
        setVneidDialog,
        submitted,
        setSubmitted,
        index,
        setIndex,
        valueForm,
        setValueForm,
        resetValueForm,
    };

    // pass the value in provider and return
    return <VNeIDJobContext.Provider value={vneidJobContext}>{children}</VNeIDJobContext.Provider>;
};

export const { Consumer } = VNeIDJobContext;
